import React from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import Scrollbars from 'react-custom-scrollbars-2';

const imgList = [
    '/images/pic/converter/converter-portfolio-gallery__item1.png',
    '/images/pic/converter/converter-portfolio-gallery__item2.png',
    '/images/pic/converter/converter-portfolio-gallery__item3.png',
    '/images/pic/converter/converter-portfolio-gallery__item4.png',
    '/images/pic/converter/converter-portfolio-gallery__item5.png',
    '/images/pic/converter/converter-portfolio-gallery__item6.png',
];

const PortfolioGallery = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper
                className="converter-portfolio-gallery"
                isMargin={false}
                bigPaddings={true}
            >
                <Scrollbars
                    renderThumbVertical={props => (
                        <div {...props} className="converter-portfolio-gallery__thumb-vertical" />
                    )}
                    style={{ maxWidth: 1400, height: '60vh' }}
                >
                    <div className="converter-portfolio-gallery__wrapper">
                        {imgList.map((item, index) => {
                            return (
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    deley={100}
                                    offset={0}
                                    animateOnce={true}
                                    duration={1}
                                    className="converter-portfolio-gallery__item"
                                    key={index}
                                >
                                    <img src={item} alt="" loading="lazy" />
                                </ScrollAnimation>
                            );
                        })}
                    </div>
                </Scrollbars>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default PortfolioGallery;
